import { router, useGlobalSearchParams, usePathname } from 'expo-router';
import { Pressable, View } from 'react-native';

import { Text } from '@squire/ui';

import { routes } from '@/constants/routes';
import { storage, storageKeys } from '@/constants/storage';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { ConfirmBookingSignInPromptProps } from './types';

export const ConfirmBookingSignInPrompt = ({
  testID,
}: ConfirmBookingSignInPromptProps) => {
  const { t } = useScreenTranslations('ConfirmBookingBottomSheet');
  const pathname = usePathname();
  const params = useGlobalSearchParams();

  const handleSignIn = () => {
    const queryString = Object.entries(params)
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
      .join('&');
    const fullPath = queryString ? `${pathname}?${queryString}` : pathname;
    storage.set(storageKeys.authReturnPath, fullPath);
    router.push(routes.signIn);
  };

  return (
    <View style={styles.signInPrompt} testID={testID}>
      <Text variant="m">{t('haveAccount')}</Text>
      <Pressable
        onPress={handleSignIn}
        accessibilityRole="link"
        accessibilityLabel={t('signIn')}
      >
        <Text variant="mStrong" color="textLink">
          {t('signIn')}
        </Text>
      </Pressable>
    </View>
  );
};
